export default __webpack_public_path__ + "static/media/C2_29.7_x_42_Blanc.54c6c194.jpg";